import { render } from "./solicitudrevisionservicios.vue?vue&type=template&id=7c6ee79a"
import script from "./solicitudrevisionservicios.vue?vue&type=script&lang=js"
export * from "./solicitudrevisionservicios.vue?vue&type=script&lang=js"

import exportComponent from "D:\\proyectos\\WSP\\Git_Luhott\\ambiental-frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__